// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export default {
    TEAM_TYPE_OPEN: 'O',
    TEAM_TYPE_INVITE: 'I',
    SORT_USERNAME_OPTION: 'Username',
} as const;
